import { render } from "./CostCenter.vue?vue&type=template&id=dec4733e&scoped=true"
import script from "./CostCenter.vue?vue&type=script&lang=js"
export * from "./CostCenter.vue?vue&type=script&lang=js"

import "./CostCenter.vue?vue&type=style&index=0&id=dec4733e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec4733e"]])

export default __exports__